import React from "react";
import Styled from "./ChipStyles";
import { Color, FONT_FAMILY, Typography } from "../../ontego-ui";

export const Chip = (props) => {
    const { id, icon = null, backgroundColor = "red", color = Color.neutral[0], children = "", fontFamily = FONT_FAMILY.ROBOTO_MEDIUM, onClick = () => { }, style, smallPadding, typographyStyle } = props

    return (
        <Styled.ChipContainer
            id={id}
            style={{
                cursor: (onClick && typeof onClick !== 'undefined') ? 'pointer' : 'auto',
                backgroundColor: backgroundColor,
                color: color,
                padding: smallPadding ? "2px 12px 2px 12px" : "4px 16px 4px 16px",
                transition: 'all 0.15s ease-in-out',
                ...style
            }}
            onClick={onClick}
        >
            {icon}
            <Typography
                id={`${id}-chip-text`}
                fontFamily={fontFamily}
                size={12}
                color={color}
                style={typographyStyle}
            >
                {(children).toUpperCase()}
            </Typography>
        </Styled.ChipContainer>
    )
}

export default React.memo(Chip)